  import React, { useEffect, useState } from 'react';
  import { 
    Box, 
    Container, 
    Paper, 
    Typography, 
    Divider, 
    Card, 
    CardContent 
  } from '@mui/material';

  const scriptData = {
    opening: "Welcome to our presentation on sustainable architecture. Today we'll explore innovative building techniques that reduce environmental impact.",
    openingNotes: "Gesture to slides, maintain eye contact with audience, speak with enthusiasm.",
    
    topicFive: "First, we'll look at the history of sustainable building practices and how they've evolved over time.",
    topicFiveNotes: "Show timeline slide, point to key milestones, mention ancient techniques still in use today.",
    
    topicFour: "Next, we'll explore modern materials that have revolutionized eco-friendly construction.",
    topicFourNotes: "Hold up material samples, allow audience to examine recycled products, highlight cost benefits.",
    
    topicThree: "Energy efficiency is our third topic, focusing on passive heating and cooling systems.",
    topicThreeNotes: "Demonstrate with 3D model, show airflow patterns, reference case studies on screen.",
    
    topicTwo: "Water conservation techniques represent our fourth area of focus.",
    topicTwoNotes: "Use water flow diagram, show before/after consumption statistics, reference successful implementations.",
    
    topicOne: "Finally, we'll discuss integration of smart technology in sustainable building design.",
    topicOneNotes: "Demo the control app, show real-time monitoring capabilities, gesture to live data on screen.",
    
    closing: "Thank you for your attention. We invite you to explore our model homes that implement all these principles.",
    closingNotes: "Distribute handouts, direct to website for more information, remain for questions."
  };

  // Script Display Component
  const ScriptPdf = ({project}) => {
    // console.log('topics scripts', project.topics)
    const [topicList, setTopicList] = useState(project?.topics);
    useEffect(()=>{
      if(project?.topics?.length > 0){
        setTopicList(project.topics)
      }
    }, [project]);


    return (
      
      <>
        {
          topicList?.length > 0 &&

          <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper elevation={3} sx={{ p: 4, mb: 4, backgroundColor: '#f8f9fa' }}>
              <Typography variant="h4" align="center" gutterBottom sx={{ color: '#2c3e50', fontWeight: 'bold', textTransform: 'capitalize' }}>
                {/* Script */}
                {project?.orgId?.organizationName}
              </Typography>
              <Typography variant="subtitle1" align="center" gutterBottom sx={{ color: '#7f8c8d', textTransform: 'capitalize' }}>
                {project?.projectName} Script With Visual Notes
              </Typography>
            </Paper>
            {
              topicList.map((scriptData)=>(
                <Card sx={{ mb: 3, border: '1px solid #e0e0e0', breakInside: "avoid", pageBreakInside: 'avoid' }}>
                  <CardContent>
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="h5" gutterBottom sx={{ 
                        color: '#1976d2', 
                        fontWeight: 'bold',
                        pb: 1,
                        borderBottom: '2px solid #1976d2',
                        textTransform: 'capitalize'
                      }}>
                        {scriptData.title}
                      </Typography>
                      <Typography variant="body1" paragraph sx={{ pl: 2 }}>
                        {scriptData.content}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ 
                      backgroundColor: '#e3f2fd', 
                      p: 2, 
                      borderRadius: 1,
                      borderLeft: '4px solid #2196f3'
                    }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                        Visual Notes:
                      </Typography>
                      <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                        {scriptData.visualNote}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              ))
            }
          </Container>
        }
      </>
    );
  };

  export default ScriptPdf;